import { Button, Dropdown, Radio, RadioChangeEvent, Row } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useCallback, useMemo } from "react";
import { PrintTaxModal } from "./PrintTaxModal";
import { usePrintOptions } from "./hooks/usePrintOptions";
import { PrintHistoryModal } from "./PrintHistory";
import { Dayjs } from "dayjs";
import { PeriodSelector } from "../../../../../../../../components/PeriodSelector";
import { usePermissions } from "../../../../../../../../lib/hooks/usePermissions";
import { CreateHistory } from "./CreateHistory";

type HeaderProps = {
  contractId: string;
  isActionsDisabled: boolean;
  isTotalsOpen: boolean;
  range: [Dayjs, Dayjs];
  setRange: React.Dispatch<React.SetStateAction<[Dayjs, Dayjs]>>;
  onRadioChange: (e: RadioChangeEvent) => void;
  onAdd: () => void;
};

export const Header = ({
  contractId,
  isActionsDisabled,
  isTotalsOpen,
  range,
  setRange,
  onRadioChange,
  onAdd,
}: HeaderProps) => {
  const { hasAccessByController } = usePermissions("PaymentHistories");

  const {
    openTaxModal,
    printOptions,
    histiryType,
    setOpenTaxModal,
    setHistoryType,
    isLoading: isPrinting,
  } = usePrintOptions(contractId, range);

  const radioOptions = useMemo(
    () => [
      { label: "Payments", value: 1 },
      { label: "Totals", value: 2 },
    ],
    [],
  );

  const onPeriodChange = useCallback(
    (dates: [Dayjs, Dayjs]) => setRange(dates),
    [setRange],
  );

  return (
    <Row className="justify-space-between">
      <Row>
        <Radio.Group
          optionType="button"
          options={radioOptions}
          onChange={onRadioChange}
          defaultValue={1}
          className="mr-4 payment-history-switcher"
          disabled={isActionsDisabled}
        />
        {!isTotalsOpen && (
          <PeriodSelector range={range} onPeriodChange={onPeriodChange} />
        )}
      </Row>
      {!isTotalsOpen && (
        <Row>
          <Dropdown
            menu={{ items: printOptions }}
            trigger={["click"]}
            className="mr-4"
            disabled={isPrinting}
          >
            <Button shape="round" className="d-inline-flex align-center ml-4">
              Print <DownOutlined />
            </Button>
          </Dropdown>

          {hasAccessByController("Add") && (
            <CreateHistory
              isActionsDisabled={isActionsDisabled}
              onAdd={onAdd}
            />
          )}

          <PrintTaxModal
            contractId={contractId}
            isOpen={openTaxModal}
            setIsOpen={setOpenTaxModal}
          />

          <PrintHistoryModal
            contractId={contractId}
            historyType={histiryType}
            setHistoryType={setHistoryType}
            range={range}
          />
        </Row>
      )}
    </Row>
  );
};
